import React, { useState } from 'react';
import config from '../config';
import { storage } from '../repository/firebase_init';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';

const BannerModal = ({ isOpen, onClose }) => {
  const { API_URL } = config;
  const [loading, setLoading] = useState(false);  
  const [error, setError] = useState(null);   
  const [imageFile, setImageFile] = useState(null);  
  const [formValues, setFormValues] = useState({
    restaurantId: '',
    title: '',
    description: '',
    status: 'pending',
    amountPaid: '',
    startDate: '',
    endDate: '',
    bannerLink: '',
    type: 'user',
  });

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const uploadImageToFirebase = async () => {
    if (!imageFile) return '';

    const imageRef = ref(storage, `banners/${imageFile.name}`);
    await uploadBytes(imageRef, imageFile);
    const downloadURL = await getDownloadURL(imageRef);
    return downloadURL;
  };

  const handleBanner = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const bannerLink = await uploadImageToFirebase();

      const updatedFormValues = { ...formValues, bannerLink };

      const response = await fetch(`${API_URL}/api/adds/addAdds`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updatedFormValues),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('Banner added successfully:', data);
      onClose();
    } catch (err) {
      console.error('Error adding banner:', err);
      setError('Failed to add banner. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-2xl shadow-lg p-6  w-[80%] relative">
        <button onClick={onClose} className="absolute top-4 right-4 text-2xl p-2 text-gray-500 hover:text-gray-700">
          x
        </button>

        <h2 className="text-xl font-semibold mb-4">Add New Advertisement</h2>

        {error && <p className="text-red-500 mb-2">{error}</p>}

        <form onSubmit={handleBanner} className="space-y-4">
          <div className='flex gap-10'>
          <div className='w-full'>
            <label className="block text-sm font-medium text-gray-700">Restaurant ID</label>
            <input
              type="text"
              name="restaurantId"
              value={formValues.restaurantId}
              onChange={handleChange}
              required
              className="mt-1 p-2 w-full border rounded-lg focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          <div className='w-full'>
            <label className="block text-sm font-medium text-gray-700">Title</label>
            <input
              type="text"
              name="title"
              value={formValues.title}
              onChange={handleChange}
              required
              className="mt-1 p-2 w-full border rounded-lg focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          </div>

          <div className='flex gap-10'>
          <div className='w-full'>
            <label className="block text-sm font-medium text-gray-700">Description</label>
            <textarea
              name="description"
              value={formValues.description}
              onChange={handleChange}
              required
              className="mt-1 p-2 w-full border rounded-lg focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          <div className='w-full'>
            <label className="block text-sm font-medium text-gray-700">Amount Paid</label>
            <input
              type="number"
              name="amountPaid"
              value={formValues.amountPaid}
              onChange={handleChange}
              required
              className="mt-1 p-2 w-full border rounded-lg focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          </div>

          <div className='flex gap-10'>
          <div className='w-full'>
            <label className="block text-sm font-medium text-gray-700">Start Date</label>
            <input
              type="date"
              name="startDate"
              value={formValues.startDate}
              onChange={handleChange}
              required
              className="mt-1 p-2 w-full border rounded-lg focus:ring-blue-500 focus:border-blue-500"
            />
          </div>

          <div className='w-full'>
            <label className="block text-sm font-medium text-gray-700">End Date</label>
            <input
              type="date"
              name="endDate"
              value={formValues.endDate}
              onChange={handleChange}
              required
              className="mt-1 p-2 w-full border rounded-lg focus:ring-blue-500 focus:border-blue-500"
            />
          </div>
          </div>

          <div className='flex gap-10'>
          <div className='w-full'>
            <label className="block text-sm font-medium text-gray-700">Banner Link</label>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              required
              className="mt-1 w-full"
            />
          </div>

          <div className='w-full'>
            <label className="block text-sm font-medium text-gray-700">Type</label>
            <select
              name="type"
              value={formValues.type}
              onChange={handleChange}
              className="mt-1 p-2 w-full border rounded-lg focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="user">User</option>
              <option value="restaurant">Restaurant</option>
              <option value="rider">Rider</option>
              <option value="admin">Admin</option>
            </select>
          </div>
          </div>

          <button
            type="submit"
            disabled={loading}
            className={`w-full ${loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'} text-white py-2 px-4 rounded-lg transition`}
          >
            {loading ? 'Adding...' : 'Add Advertisement'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default BannerModal;
